// extracted by mini-css-extract-plugin
export default {"banner":"Investigation_banner__-EK+Y"};